import { Progress } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { BookDummy } from 'assets';
import PlayWithoutRing from 'assets/Icons/PlayWithoutRing';
import { motion } from 'framer-motion';
import Image from 'next/image';

import { Endpoints } from '@/network';
import { generateUrlForImage } from '@/pages/books/[bookId]';
import type { BookInteraction } from '@/utils/interfaces/Library/Books/MyBook';

interface BookCardProps {
  item: BookInteraction;
  index: number;
  cardClickHandler: ({
    bookId,
    chapterId,
    chapterPageNumber,
    bookType,
  }: {
    bookId: string;
    chapterId?: string;
    chapterPageNumber?: number;
    bookType?: string;
  }) => void;
}

const ContinueReadingBookCard = ({
  item,
  index,
  cardClickHandler,
}: BookCardProps) => {
  const base_Url = process.env.NEXT_PUBLIC_API_READER_URL as string;
  const screens = useBreakpoint();

  const itemAnimation = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        delay: index * 0.05,
      },
    },
  };

  return (
    <motion.div
      className='w-full max-w-xs overflow-hidden transition-all rounded-lg h-full cursor-pointer duration-300 bg-cartBgColor min-w-[260px] md:min-w-[350px] xl:min-w-[400px]'
      variants={itemAnimation}
      onClick={() =>
        cardClickHandler({
          bookId: item?.book?._id,
          chapterId: item?.lastPageRead?.chapter,
          chapterPageNumber: item?.lastPageRead?.pageNumber,
          bookType: item.book.type,
        })
      }
    >
      <div className=' rounded-lg overflow-hidden border border-[#282829] h-full'>
        <div className='flex items-center h-full'>
          <div className='relative max-w-[71px]  md:max-w-[95px] bg-[#121212] p-3 overflow-hidden rounded'>
            <Image
              src={
                generateUrlForImage(
                  `${base_Url}/`,
                  `${Endpoints.getCoverImagesForBooks}/`,
                  `${item?.book?._id}`,
                ) || BookDummy
              }
              width={71}
              height={100}
              alt={item?.book?.title || 'Book cover'}
              className='h-full w-full rounded-sm min-w-[40px] md:min-w-[65px]  '
            />
          </div>
          <div className='flex  px-3 pt-2 md:pt-4 pb-1 md:pb-3 justify-between w-full h-full'>
            <div className='flex flex-col  h-full w-full'>
              <div className='text-textLightGray text-[10px] md:text-xs font-light'>
                {item?.book?.author_list?.[0]?.name || 'ZebraLearn'}
              </div>

              <h3 className='text-white font-semibold max-w-[163px] lg:max-w-[263px] text-xs md:text-base truncate'>
                {item?.book?.title}
              </h3>
              <div className='mt-auto'>
                <div className='flex justify-between translate-y-1'>
                  <span className='text-textGrayColor text-[10px] md:text-xs'>
                    {item?.lastPageRead?.pageNumber || 0} of{' '}
                    {item?.book?.totalPages} Pages
                  </span>
                  <span>
                    <PlayWithoutRing width={screens.md ? '24' : '16'} />
                  </span>
                </div>

                <div className='flex flex-col '>
                  <Progress
                    percent={
                      (item?.lastPageRead?.pageNumber /
                        item?.book?.totalPages) *
                      100
                    }
                    showInfo={false}
                    className='customProcessBar'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ContinueReadingBookCard;
